import { render, staticRenderFns } from "./OfferForm.vue?vue&type=template&id=2d05a62a"
import script from "./OfferForm.vue?vue&type=script&lang=js"
export * from "./OfferForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports